import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'creditCard'
})
export class CreditCardPipe implements PipeTransform {

  constructor() { }

  transform(value: string): any {
    if (value && value !== 'undefined') {
      const finalArray = [];

      // remove all dashes from string
      const rawCreditCard = this.removeDashFromCreditCard(value);

      // get current length of the string
      const creditCardLength = rawCreditCard.length;

      switch (true) {

        // if length === 0 || 1 || 2
        case creditCardLength > 0 && creditCardLength <= 4: {
          finalArray.push(rawCreditCard);
        } break;

        // if length === 3 || 4 || 5 || 6
        case creditCardLength > 4 && creditCardLength <= 8: {
          const part1 = rawCreditCard.slice(0, 4);
          const part2 = rawCreditCard.slice(4, 8);

          finalArray.push(part1);
          finalArray.push(part2);

        } break;

        // if length === 7 || 8 || 9 || 10
        case creditCardLength > 8 && creditCardLength <= 12: {
          const part1 = rawCreditCard.slice(0, 4);
          const part2 = rawCreditCard.slice(4, 8);
          const part3 = rawCreditCard.slice(8, 12);

          finalArray.push(part1);
          finalArray.push(part2);
          finalArray.push(part3);
        }; break;

        case creditCardLength > 12 && creditCardLength <= 16: {
          const part1 = rawCreditCard.slice(0, 4);
          const part2 = rawCreditCard.slice(4, 8);
          const part3 = rawCreditCard.slice(8, 12);
          const part4 = rawCreditCard.slice(12, 16);

          finalArray.push(part1);
          finalArray.push(part2);
          finalArray.push(part3);
          finalArray.push(part4);
        }; break;

        // a complete creditcard number
        case creditCardLength === 16: {
          const part1 = rawCreditCard.slice(0, 4);
          const part2 = rawCreditCard.slice(4, 8);
          const part3 = rawCreditCard.slice(8, 12);
          const part4 = rawCreditCard.slice(12, 16);
          finalArray.push(part1);
          finalArray.push(part2);
          finalArray.push(part3);
          finalArray.push(part4);
        } break;

        // orherwise
        default: break;
      }

      return finalArray.join(' - ');
    } else {
      return null;
    }
  }


  private removeDashFromCreditCard(value: string | number): string {
    if (typeof value === 'string') {
      return value.includes('-')
        ? value.split(' - ').join('')
        : value;

    } else {
      const stringValue = value.toString();
      return stringValue.split(' - ').join('');
    }
  }

}
